import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import {
  ALL_TIMEZONE_DISPLAY_MODES,
  type TimezoneDisplayMode,
} from "features/integrationsBeta/timezoneDisplay";

const LABELS: Record<TimezoneDisplayMode, string> = {
  local: "Local",
  utc: "UTC",
  client: "Client",
};

/**
 * Local / UTC / Client switch for run-timestamp display. "Client" renders
 * each timestamp in the owning integration's timezone (grey abbreviation
 * next to the time). Client-facing pages pass `modes` without "client".
 */
export default function TimezoneDisplayToggle({
  mode,
  onChange,
  height,
  modes = ALL_TIMEZONE_DISPLAY_MODES,
}: {
  mode: TimezoneDisplayMode;
  onChange: (mode: TimezoneDisplayMode) => void;
  /** Pin the group to a control row height (e.g. FILTER_FIELD_H = 40). */
  height?: number;
  /** The choices offered, in order (default: all three). */
  modes?: readonly TimezoneDisplayMode[];
}) {
  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      value={mode}
      onChange={(_, next: TimezoneDisplayMode | null) => {
        if (next) onChange(next);
      }}
      aria-label="Timestamp timezone"
      sx={{
        ...(height ? { height } : {}),
        "& .MuiToggleButton-root": {
          px: 1.5,
          py: 0.5,
          ...(height ? { height } : {}),
        },
      }}
    >
      {modes.map((value) => (
        <ToggleButton key={value} value={value}>
          {LABELS[value]}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
